
import { createApp } from 'vue'
import App from './Index_new.vue'

import PrimeVue from 'primevue/config';
import Dialog from 'primevue/dialog';

import SlideUpDown from 'vue3-slide-up-down';
import { VueCookieNext } from 'vue-cookie-next';

import VueGoogleMaps from '@fawmi/vue-google-maps';



let app = createApp(App);

app.use(PrimeVue);
app.component('Dialog', Dialog);
app.use(VueCookieNext);
VueCookieNext.config({ expire: '1m' });
app.component('slide-up-down', SlideUpDown);

app.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCxCb7iRkeG6pVT-_6tjVC2glQZK2UF59s',
        libraries: "places"
    },
});

app.mount('#app');
